import React, { Fragment } from 'react';
import { GiAnticlockwiseRotation } from 'react-icons/gi';

import PerfectScrollBar from 'react-perfect-scrollbar';
import { Col, Card } from 'react-bootstrap';

import PieChart from '../../components/hightchart/pieChart';
import { numberFormat } from '../../utils';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import { translate } from 'react-i18next';
class BaoCaoTaiSan extends React.PureComponent {
  render() {
    const { cashBalance, account, t } = this.props;
    const _perStock = Math.ceil(
      cashBalance && cashBalance.stockVal
        ? (cashBalance.stockVal * 100) / cashBalance.assets
        : 0
    );
    const _perDebt = Math.ceil(
      cashBalance && cashBalance.debt
        ? (cashBalance.debt * 100) / cashBalance.assets
        : 0
    );
    const asset1 = {
      name: t('txt-label-cash'),
      value: 100 - _perStock,
      color: '#1BA0E1',
    };
    const asset2 = {
      name: t('txt-label-position'),
      value: _perStock,
      color: '#ffb613',
    };
    const debt1 = {
      name: t('txt-nav'),
      value: 100 - _perDebt,
      color: '#03FF04',
    };
    const debt2 = { name: t('txt-debt'), value: _perDebt, color: '#44d7b6' };
    console.log(asset1, asset2);
    return (
      <Fragment>
        <div className="d-flex flex-row mt-3 mb-2">
          <span className="ml-2 text-white" style={{ fontSize: '18px' }}>
            {t('txt-title-asset-manage')}
          </span>
          &nbsp;
          <span
            className="mr-auto font-weight-bold text-white"
            style={{ fontSize: '18px' }}
          >
            {account &&
              account.value +
                ' - ' +
                (account.value.startsWith('M') ? 'Margin' : t('txt-normal'))}
          </span>
          <a
            className="mr-3 btn-reload"
            onClick={() => {
              this.props.reload();
            }}
          >
            <GiAnticlockwiseRotation className="fz-14 text-white" />
          </a>
        </div>
        <PerfectScrollBar style={{ height: 'calc(100% - 155px)' }}>
          <div className="d-flex flex-row">
            <Col className="d-flex flex-column pr-0">
              <Card>
                <Card.Header className="pl-2">{t('txt-asset')}</Card.Header>
                <Card.Body>
                  {cashBalance && <PieChart data1={asset1} data2={asset2} />}
                </Card.Body>
              </Card>
              <table className="table table-bordered mt-2">
                <thead>
                  <tr>
                    <th className="text-right">{t('txt-asset-total')}</th>
                    <th className="text-right">{t('txt-asset-nav')}</th>
                    <th className="text-right">{t('txt-asset-withdrawal')}</th>
                    <th className="text-right">
                      {t('txt-asset-receivable-1')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-right text-white">
                      {cashBalance && numberFormat(cashBalance.assets, 0, '0')}
                    </td>
                    <td className="text-right text-white">
                      {cashBalance && numberFormat(cashBalance.nav, 0, '0')}
                    </td>
                    <td className="text-right text-white">
                      {cashBalance &&
                        numberFormat(cashBalance.wdrawAvail, 0, '0')}
                    </td>
                    <td className="text-right text-white">
                      {cashBalance &&
                        numberFormat(cashBalance.advanceAvail, 0, '0')}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="table table-bordered mt-2">
                <thead>
                  <tr>
                    <th className="text-left" colSpan="2">
                      <span className="text-uppercase">
                        {t('txt-asset-balance')}
                      </span>
                      <Link
                        to="sao-ke-tien"
                        className="float-right font_14 color-lightning"
                      >
                        {t('txt-detail')}
                        <FaChevronRight
                          style={{ paddingBottom: '2px' }}
                          className="ml-2"
                        />
                      </Link>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-left">{t('txt-asset-cash-balance')}</td>
                    <td className="text-right text-white">
                      {cashBalance &&
                        numberFormat(cashBalance.cashBalance, 0, '0')}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-left">
                      {t('txt-asset-receivable-amount')}
                    </td>
                    <td className="text-right text-white">
                      {cashBalance && numberFormat(cashBalance.sellAmt, 0, '0')}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-left">{t('txt-asset-buy-mount')}</td>
                    <td className="text-right text-white">
                      {cashBalance && numberFormat(cashBalance.buyAmt, 0, '0')}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-left">
                      {t('txt-asset-unmatch-amount')}
                    </td>
                    <td className="text-right text-white">
                      {cashBalance &&
                        numberFormat(cashBalance.unmatchAmt, 0, '0')}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-left">{t('txt-asset-collateral')}</td>
                    <td className="text-right text-white">
                      {cashBalance &&
                        numberFormat(cashBalance.collateral, 0, '0')}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="table table-bordered mt-2">
                <thead>
                  <tr>
                    <th className="text-left" colSpan="2">
                      <span className="text-uppercase">
                        {t('txt-asset-stocks')}
                      </span>
                      <Link
                        to="sao-ke-chung-khoan"
                        className="float-right font_14 color-lightning"
                      >
                        {t('txt-detail')}
                        <FaChevronRight
                          style={{ paddingBottom: '2px' }}
                          className="ml-2"
                        />
                      </Link>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-left">
                      {t('txt-asset-market-stocks')}
                    </td>
                    <td className="text-right text-white">
                      {cashBalance &&
                        numberFormat(cashBalance.stockVal, 0, '0')}
                    </td>
                  </tr>
                  {/* <tr>
                    <td className="text-left">{t('txt-asset-guaranteed')}</td>
                    <td className="text-right text-white">
                      {cashBalance &&
                        numberFormat(cashBalance.marginVal, 0, '0')}
                    </td>
                  </tr> */}
                  <tr>
                    <td className="text-left">
                      {t('txt-asset-collateral-stock')}
                    </td>
                    <td className="text-right text-white">
                      {cashBalance && numberFormat(cashBalance.righVal, 0, '0')}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
            <Col className="d-flex flex-column">
              <Card>
                <Card.Header className="pl-2">{t('txt-debt')}</Card.Header>
                <Card.Body>
                  {cashBalance && <PieChart data1={debt1} data2={debt2} />}
                </Card.Body>
              </Card>
              <table className="table table-bordered mt-2">
                <thead>
                  <tr>
                    <th className="text-right">
                      {t('txt-asset-outstanding-debt')}
                    </th>
                    <th className="text-right">{'RTT'}</th>
                    <th className="text-right">{t('txt-asset-adding')}</th>
                    <th className="text-right">
                      {t('txt-asset-remain-margin')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-right text-white">
                      {cashBalance && numberFormat(cashBalance.debt, 0, '0')}
                    </td>
                    <td className="text-right text-white">
                      {cashBalance &&
                        numberFormat(cashBalance.marginRate, 2, '0')}
                      %
                    </td>
                    <td className="text-right text-white">{'-'}</td>
                    <td className="text-right text-white">{'-'}</td>
                  </tr>
                </tbody>
              </table>
              <table className="table table-bordered mt-2">
                <thead>
                  <tr>
                    <th className="text-left" colSpan="2">
                      <span className="text-uppercase">{t('txt-debt')}</span>
                      <Link
                        to="bao-cao-no"
                        className="float-right font_14 color-lightning"
                      >
                        {t('txt-detail')}
                        <FaChevronRight
                          style={{ paddingBottom: '2px' }}
                          className="ml-2"
                        />
                      </Link>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-left">{t('txt-asset-day-loan')}</td>
                    <td className="text-right text-white">
                      {cashBalance &&
                        numberFormat(cashBalance.debtInday, 0, '0')}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-left">{t('txt-asset-principal')}</td>
                    <td className="text-right text-white">
                      {cashBalance &&
                        numberFormat(cashBalance.debtBegin, 0, '0')}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-left">
                      {t('txt-asset-margin-loan-interest')}
                    </td>
                    <td className="text-right text-white">
                      {cashBalance &&
                        numberFormat(cashBalance.loan_fee, 0, '0')}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="table table-bordered mt-2">
                <thead>
                  <tr>
                    <th className="text-left" colSpan="2">
                      <span className="text-uppercase">
                        {t('txt-label-fee')}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-left">
                      {t('txt-asset-month-depo-fee')}
                    </td>
                    <td className="text-right text-white">
                      {cashBalance && numberFormat(cashBalance.depoFee, 0, '0')}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-left">{t('txt-asset-other-fee')}</td>
                    <td className="text-right text-white">
                      {cashBalance &&
                        numberFormat(cashBalance.othersLoan, 0, '0')}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </div>
          <div className=""></div>
        </PerfectScrollBar>
      </Fragment>
    );
  }
}

export default translate('translations')(BaoCaoTaiSan);
